import React, { useState, useEffect } from "react";
import useQRScanner from "../utils/useQrCode";
import { WhiteBoxWrapper, VideoScanBar, VideoWrapper } from "./Login.style";
import { Alert } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { fetchAPI } from "../utils/fetchAPI";

const AddUserForm: React.FC = () => {
  const [login, setLogin] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [firstName, setFirstName] = useState<string>("");
  const [lastName, setLastName] = useState<string>("");
  const [position, setPosition] = useState<string>("");
  const [qrCodeForm, setQrCodeForm] = useState<string>("");
  const [photo, setPhoto] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const { videoRef, qrCode, setQrCode, error: cameraError } = useQRScanner();
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const sendQRCode = async () => {
      if (!qrCode) return;
      setIsLoading(true);
      setErrorMessage("");

      const data = await fetchAPI("POST", "checkqr.php", { qr: qrCode });

      if (data.success) {
        setQrCodeForm("");
        setErrorMessage("Kod QR już jest wykorzystany");
      } else {
        setQrCodeForm(qrCode);
      }

      setIsLoading(false);
    };

    sendQRCode();
  }, [qrCode, setQrCode]);

  const handleSendData = async () => {
    if (!login || !password || !firstName || !lastName || !qrCodeForm || !position) {
      alert("Wypełnij wszystkie pola i zeskanuj kod QR.");
      return;
    }

    const userData = {
      login,
      password,
      firstName,
      lastName,
      qrCodeForm,
      position,
      photo,
    };

    try {
      setLoading(true);
      await fetchAPI("POST", "adduser.php", userData);

      // Czyszczenie formularza po wysłaniu
      setLogin("");
      setPassword("");
      setFirstName("");
      setLastName("");
      setQrCodeForm("");
      setPosition("");
      setPhoto(null);
      navigate("/users");
    } catch (error) {
      console.error("Failed to send data:", error);
      alert("Błąd podczas wysyłania danych na serwer.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="">
      <WhiteBoxWrapper>
        <h2 className="text-center">Dodaj pracownika</h2>
      </WhiteBoxWrapper>
      <form onSubmit={(e) => e.preventDefault()}>
        <div className="mb-4">
          <label className="form-label">Kod QR</label>
          {qrCode && <div className="text-green-600">Zaczytany kod QR: {qrCode}</div>}
          <div>
            <VideoWrapper>
              <video ref={videoRef} className="w-full border rounded mb-2" />
              <VideoScanBar />
            </VideoWrapper>
          </div>
          {cameraError && <Alert variant="warning">{cameraError}</Alert>}
          {errorMessage && <Alert variant="danger">{errorMessage}</Alert>}
        </div>

        <div className="mb-4">
          <label className="form-label" htmlFor="login">
            Login
          </label>
          <input
            type="text"
            id="login"
            value={login}
            onChange={(e) => setLogin(e.target.value)}
            className="form-control"
            required
          />
        </div>

        <div className="mb-4">
          <label className="form-label" htmlFor="password">
            Hasło
          </label>
          <input
            type="password"
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="form-control"
            required
          />
        </div>

        <div className="mb-4">
          <label className="form-label" htmlFor="firstName">
            Imię
          </label>
          <input
            type="text"
            id="firstName"
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
            className="form-control"
            required
          />
        </div>

        <div className="mb-4">
          <label className="form-label" htmlFor="lastName">
            Nazwisko
          </label>
          <input
            type="text"
            id="lastName"
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
            className="form-control"
            required
          />
        </div>

        <div className="mb-4">
          <label className="form-label">Stanowisko</label>
          <input
            type="text"
            value={position}
            onChange={(e) => setPosition(e.target.value)}
            className="form-control"
            required
          />
        </div>

        {isLoading && <p>Przetwarzanie kodu...</p>}

        <button
          type="button"
          onClick={handleSendData}
          disabled={loading}
          className={`btn btn-primary w-100 p-3 ${loading ? "bg-gray-400" : "bg-blue-600"}`}
        >
          {loading ? "Wysyłanie..." : "Dodaj +"}
        </button>
      </form>
    </div>
  );
};

export default AddUserForm;
